<template>
  <div>
    <br/>
    <br/>
    <br/>
    <br/>
    <h3 class="title text-center">Ha finalizado correctamente.</h3>
  </div>
</template>
<script>
export default {
  name: "Pperedirect",
  methods: {
    startwin () {
      window.open("http://localhost:8080/ppe/tramite", "tramite", "width=800,height=600");
    }
  },
  mounted () {
    document.getElementsByClassName("app-nav")[0].remove();
    setTimeout(() => {
      window.close();
    }, 2000);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/pperedirect.vue